import { StrictNullable } from '@/shared/types/app.types'
import i18n from '@/lang/i18n'

export enum BillingSearcherMode {
    PATIENT = 'PATIENT',
    CASE = 'CASE',
    DELIVERY_NOTE = 'DELIVERY_NOTE',
    CUSTOMER = 'CUSTOMER',
    INVOICE = 'INVOICE',
    INVOICE_PAYMENT = 'INVOICE_PAYMENT',
    INVOICE_RECEIPT = 'INVOICE_RECEIPT'
}
export interface BillingSearcherModeInfo {
    mode: BillingSearcherMode
    label: string
    icon: string
}
export const getSearcherModeInfo =
    (mode: BillingSearcherMode): StrictNullable<BillingSearcherModeInfo> => {
        switch (mode) {
        case BillingSearcherMode.PATIENT:
            return { mode, label: i18n.tc('component.searcher.patient'), icon: 'fal fa-user-circle' }
        case BillingSearcherMode.CASE:
            return { mode, label: i18n.tc('global.case'), icon: 'fal fa-chart-network' }
        case BillingSearcherMode.DELIVERY_NOTE:
            return { mode, label: i18n.tc('accounting.field.deliveryNote'), icon: 'fal fa-ballot' }
        case BillingSearcherMode.CUSTOMER:
            return { mode, label: i18n.tc('accounting.field.client'), icon: 'far fa-address-book' }
        case BillingSearcherMode.INVOICE:
            return { mode, label: i18n.tc('accounting.field.invoice'), icon: 'fal fa-file-invoice-dollar' }
        case BillingSearcherMode.INVOICE_PAYMENT:
            return { mode, label: i18n.tc('accounting.field.invoicePayment'), icon: 'fal fa-credit-card-front' }
        case BillingSearcherMode.INVOICE_RECEIPT:
            return { mode, label: i18n.tc('accounting.field.invoiceReceipt'), icon: 'far fa-envelope-open-dollar' }
        }
        return null
    }

export enum BillingSearcherCaseMode {
    IDENTIFIER = 'IDENTIFIER',
    INSURANCE_DOCUMENT = 'INSURANCE_DOCUMENT',
    INSURANCE_POLICY = 'INSURANCE_POLICY'
}
export interface BillingSearcherCaseModeInfo {
    mode: BillingSearcherCaseMode
    label: string
}
export const caseScopes =
    (): BillingSearcherCaseModeInfo[] => [
        { mode: BillingSearcherCaseMode.IDENTIFIER, label: i18n.tc('global.identifier') },
        { mode: BillingSearcherCaseMode.INSURANCE_DOCUMENT, label: i18n.tc('global.insuranceDocument') },
        { mode: BillingSearcherCaseMode.INSURANCE_POLICY, label: i18n.tc('accounting.field.insurancePolicy') }
    ]

export interface BillingSearcherParams {
    mode: BillingSearcherMode
    caseScope?: BillingSearcherCaseMode
    patientsIds?: number[]
    identifierSearch?: string
}

export interface BillingSearcherState {
    searcherMode: StrictNullable<BillingSearcherModeInfo>
    caseMode: StrictNullable<BillingSearcherCaseMode>
}
export const initialBillingSearcherState =
    (): BillingSearcherState => ({
        searcherMode: null,
        caseMode: null
    })
